<template>
  <ToolTip ref="ToolTipRef" />
  <!-- <div v-if="visible" class="row alert alert-aprs align-items-center" role="alert"> -->
  <div v-if="visible" class="navbar navbar-dark bg-dark border-secondary justify-content-center border-bottom">
    <div class="col-md-6 py-1 text-center">{{ t('You have selected:') }} <span class="fw-bold text-nowrap">{{ call }} /
        {{ date }}</span></div>
    <div class="d-flex col-md-6 py-2 justify-content-center">
      <div class="px-1"><button type="button" class="btn btn-outline-light" @click="emits('emitNewSearch', call)">{{t('New Search') }}</button></div>
      <div class="px-1"><button type="button" class="btn btn-outline-light btn-fill px-2 position-relative" style="width: 40px;"
          @click="urlToClipboard()">&nbsp;
          <svg class="position-absolute top-50 start-50 translate-middle" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24" width="18" height="18">
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              d="M7 6V3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-3v3c0 .552-.45 1-1.007 1H4.007A1.001 1.001 0 0 1 3 21l.003-14c0-.552.45-1 1.007-1H7zM5.003 8L5 20h10V8H5.003zM9 6h8v10h2V4H9v2z" />
          </svg>
        </button></div>
    </div>
  </div>
</template>


<script setup>
import { ref, defineEmits, defineExpose } from 'vue'
import { useI18n } from 'vue-i18n'
import { copyToClipboard } from '../js/tmlf.js'
import ToolTip from './ToolTip.vue'

const { t } = useI18n()

const emits = defineEmits(['emitNewSearch'])

const visible = ref(false)
const call = ref()
const date = ref()
const tab = ref()
const ToolTipRef = ref()

defineExpose({
  visible,
  call,
  date,
  tab,
});

function urlToClipboard() {
  let url = new URL(window.location.href)
  url = url.origin+'/aprs/?call='+call.value+'&date='+date.value
  if (tab.value) {
    url = url + '&tab=' + tab.value
  }
  copyToClipboard(url)
    // .then(() => alert(t('Copied to Clipboard! ') + url))
    .then(() => ToolTipRef.value.showToolTip(t('Copied URL to Clipboard! ')))
    .catch(() => console.log('error copy to clipboard'));
}

</script>

<style>
.btn-fill {
  fill: var(--bs-light)
}

.btn-fill:hover {
  fill: var(--bs-dark)
}
</style>

<i18n>
  {
    "pl": {
      "You have selected:": "Wybrano:",
      "New Search": "Nowe Wyszukiwanie",
      "Copied URL to Clipboard! ": "Skopiowano adres URL do schowka: "
    }
  }
</i18n>
